var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { id: "accounts-reports", tag: "section" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _vm._v(" " + _vm._s(_vm.title) + " "),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "secondary" },
                  on: { click: _vm.exportData }
                },
                [_c("v-icon", [_vm._v("mdi-download")])],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-container",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        [
                          _c("v-text-field", {
                            staticClass: "searchBox",
                            attrs: {
                              "append-icon": "mdi-magnify",
                              label: _vm.$t("global.search"),
                              "single-line": "",
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.search,
                              callback: function($$v) {
                                _vm.search = $$v
                              },
                              expression: "search"
                            }
                          })
                        ],
                        1
                      ),
                      _c("v-spacer"),
                      _c("v-spacer"),
                      _c("v-spacer"),
                      _c(
                        "v-col",
                        [
                          [
                            _c(
                              "div",
                              { staticClass: "text-center" },
                              [
                                _c("v-autocomplete", {
                                  attrs: {
                                    items: _vm.months,
                                    "item-text": "name",
                                    "item-value": "id",
                                    label: "Select a period",
                                    "return-object": "",
                                    autocomplete: "off"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.selectMonth(_vm.period)
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "append-item",
                                      fn: function() {
                                        return undefined
                                      },
                                      proxy: true
                                    }
                                  ]),
                                  model: {
                                    value: _vm.period,
                                    callback: function($$v) {
                                      _vm.period = $$v
                                    },
                                    expression: "period"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-data-table", {
                attrs: {
                  filterable: "",
                  headers: _vm.computedHeaders.map(function(x) {
                    return Object.assign({}, x, { text: _vm.$t(x.text) })
                  }),
                  items: _vm.items,
                  "item-key": "id",
                  loading: _vm.loading,
                  search: _vm.search,
                  "items-per-page": _vm.rowsPerPage
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.organisation",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "a",
                          {
                            attrs: { href: _vm.createAccountDashboardURL(item) }
                          },
                          [_vm._v(" " + _vm._s(item.organisation) + " ")]
                        )
                      ]
                    }
                  },
                  {
                    key: "item.sessions",
                    fn: function(ref) {
                      var item = ref.item
                      return [_vm._v(" " + _vm._s(item.sessions) + " ")]
                    }
                  },
                  {
                    key: "item.activityChange",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "v-chip",
                          {
                            attrs: {
                              color: _vm.activityChangeColor(
                                item.activityChange
                              )
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.displayActivityChange(
                                    item.sessions,
                                    item.activityChange
                                  )
                                ) +
                                " "
                            )
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "item.recommend",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "v-chip",
                          {
                            attrs: {
                              color: _vm.recommendColor(
                                item.recommend,
                                item.sessions
                              )
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    item.recommend >= 0
                                      ? item.recommend + "%"
                                      : "N/A"
                                  )
                              )
                            ])
                          ]
                        )
                      ]
                    }
                  },
                  {
                    key: "item.registeredUsers",
                    fn: function(ref) {
                      var item = ref.item
                      return [_vm._v(" " + _vm._s(item.registeredUsers) + " ")]
                    }
                  },
                  {
                    key: "item.registeredAdmins",
                    fn: function(ref) {
                      var item = ref.item
                      return [_vm._v(" " + _vm._s(item.registeredAdmins) + " ")]
                    }
                  },
                  {
                    key: "item.maxUsers",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              item.maxUsers === 0 ? "Unlimited" : item.maxUsers
                            ) +
                            " "
                        )
                      ]
                    }
                  },
                  {
                    key: "item.maxDevices",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              item.maxDevices === 0
                                ? "Unlimited"
                                : item.maxDevices
                            ) +
                            " "
                        )
                      ]
                    }
                  },
                  {
                    key: "item.maxSessions",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              item.maxSessions === 0
                                ? "Unlimited"
                                : item.maxSessions
                            ) +
                            " "
                        )
                      ]
                    }
                  },
                  {
                    key: "item.expiryDate",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("span", { class: _vm.textColor(item.expiryDate) }, [
                          _vm._v(_vm._s(_vm.displayTime(item.expiryDate)))
                        ])
                      ]
                    }
                  },
                  {
                    key: "item.ageMonths",
                    fn: function(ref) {
                      var item = ref.item
                      return [_vm._v(" " + _vm._s(item.ageMonths) + " ")]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.userRoleIs("developer")
        ? _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v("Report Management")]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    [
                      _c("date-range-picker", {
                        attrs: { "text-color": _vm.datePickerColor },
                        on: { datesChange: _vm.reportDatesChanged }
                      }),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "blue",
                            disabled: _vm.query.processingReport
                          },
                          on: { click: _vm.generateNewReport }
                        },
                        [_vm._v(" Create ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "red",
                            disabled: _vm.query.processingReport
                          },
                          on: { click: _vm.deleteReport }
                        },
                        [_vm._v(" Delete ")]
                      ),
                      _c("p", [
                        _c("span", { attrs: { color: "red" } }, [
                          _vm._v(" " + _vm._s(_vm.error) + " ")
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-overlay",
        { attrs: { value: _vm.busy } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }